import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import useStore from '../store';
import signUpImage from '../Assets/Images/flow-sign-up_s.jpg';

const SignUpDialog = () => {
    const showSignUpDialog = useStore((state) => state.showSignUpDialog);
    const signUpDialogReason = useStore((state) => state.signUpDialogReason);
    const setShowSignUpDialog = useStore((state) => state.setShowSignUpDialog);
    const setShowLoginDialog = useStore((state) => state.setShowLoginDialog);
    const resetEngineRunCount = useStore((state) => state.resetEngineRunCount);

    const isRunLimit = signUpDialogReason === 'runLimit';
    const isPremiumNode = signUpDialogReason === 'premiumNode';

    const handleClose = () => {
        setShowSignUpDialog(false);
        // Only reset run count if this was triggered by run limit
        if (isRunLimit) {
            resetEngineRunCount();
        }
    };

    const handleSignUp = () => {
        setShowSignUpDialog(false);
        // Only reset run count if this was triggered by run limit
        if (isRunLimit) {
            resetEngineRunCount();
        }
        setShowLoginDialog(true);
    };

    return (
        <Dialog
            open={showSignUpDialog}
            onClose={handleClose}
        >
            <DialogContent>
                <Box sx={{ py: 2 }}>
                    <Box
                        component="img"
                        src={signUpImage}
                        alt="Sign up"
                        sx={{
                            width: '100%',
                            maxHeight: 300,
                            objectFit: 'cover',
                            borderRadius: 1,
                            mb: 2
                        }}
                    />
                    {isRunLimit && (
                        <>
                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                                Unlock more features.
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                Create a free Peregrine Flow account to keep going and unlock:
                            </Typography>
                            <Box component="ul" sx={{ mt: 2, pl: 2 }}>
                                <Typography component="li" variant="body2">
                                    Media downloads
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Saved custom workflows and results
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Unlimited workflow runs
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Share projects with others
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Access from any device
                                </Typography>
                            </Box>
                        </>
                    )}
                    {isPremiumNode && (
                        <>
                            <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                                Create a free account to continue
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                You're trying to use a feature that's available to signed-in users.
                            </Typography>
                            <Typography variant="body1" gutterBottom>
                                Create a free Peregrine Flow account to keep going and unlock:
                            </Typography>
                            <Box component="ul" sx={{ mt: 2, pl: 2 }}>
                                <Typography component="li" variant="body2">
                                    Media downloads
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Saved projects and results
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Share projects with others
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Unlimited workflow runs
                                </Typography>
                                <Typography component="li" variant="body2">
                                    Access from any device
                                </Typography>
                            </Box>
                        </>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    Maybe Later
                </Button>
                <Button onClick={handleSignUp} variant="contained" color="primary">
                    Sign Up Now
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SignUpDialog;
